export default "__VITE_ASSET__DZpaN4ey__"